// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { withRouter } from 'react-router-dom';

import api from '../../api';

// Components
import User from '../User';

// Styles
import '../../styles/public.css';

class Slack extends React.Component {
    componentDidMount = async () => {
        await this.props.loading();
        await api.post('/sync/slack', {
            code: new URLSearchParams(this.props.location.search).get('code')
        });
        window.close();
    }

    render = () => {
        document.title = "Connect to Slack | Stax·ai"
        return (<>

            {/* Stax·ai logo */}
            <div className="public-logo" onClick={() => window.open('https://stax.ai')}>
                <img
                    src="https://static.stax.ai/images/logo/color.svg"
                    alt="[Stax·ai Logo]"
                />STAX<div className="navigation-logo-dot"></div>AI
            </div>

            {/* User icon */}
            <User
                className="public-user"
                clearNotification={this.props.clearNotification}
                user={this.props.user}
                updateUser={this.props.updateUser}
                switchTeam={this.props.switchTeam}
                team={this.props.team}
            />

        </>);
    }
}

export default withRouter(Slack);